import "@gss/css/bootstrap.scss";
import "@gss/css/common.css";

import type { JSX } from "preact";
import { render } from "preact";
import { Auth } from "@gss/common/Auth";
import { getRootElement } from "@gss/common/getRootElement";
import { LoadingBar } from "./LoadingBar";
import { Menu } from "./Menu";
import { MessageProvider, Messages, useMessages } from "./Messages";

// Index from sub module. Start point of specific page/war js.
import { Index } from "Index";

function renderApp(initialError?: unknown): void {
    render(
        <MessageProvider initialError={initialError}>
            <Menu />
            <LoadingBar />
            <main>
                <Messages />
                {initialError == null && <IndexWrapper />}
            </main>
        </MessageProvider>,
        getRootElement(),
    );
}

function IndexWrapper(): JSX.Element {
    const { addError } = useMessages();

    Auth.onAuthRefreshError((cause) => {
        addError({
            message: "Problem med inloggningen",
            cause,
        });
    });

    return <Index />;
}

void (async () => {
    // Necessary to use the preact dev tools browser plugin.
    if (import.meta.env.DEV) {
        await import("preact/debug");
    }

    try {
        await Auth.initLoginRequired();

        // Check minimal role requirement for authenticated users.
        if (Auth.isReader()) {
            renderApp();
        } else {
            renderApp("Du saknar behörighet för denna applikation");
        }
    } catch (error: unknown) {
        renderApp(error);
    }
})();
